__turbopack_context__.v({
  "comments-container": "ReviewComments-module-scss-module__69nl8G__comments-container",
  "comments-form-heading": "ReviewComments-module-scss-module__69nl8G__comments-form-heading",
  "comments-title": "ReviewComments-module-scss-module__69nl8G__comments-title",
  "comments-title-heading": "ReviewComments-module-scss-module__69nl8G__comments-title-heading",
  "comments-title-mobile": "ReviewComments-module-scss-module__69nl8G__comments-title-mobile",
  "review-comments-star": "ReviewComments-module-scss-module__69nl8G__review-comments-star",
  "reviews-comments-star": "ReviewComments-module-scss-module__69nl8G__reviews-comments-star",
  "reviews-info": "ReviewComments-module-scss-module__69nl8G__reviews-info",
  "reviews-info-mobile": "ReviewComments-module-scss-module__69nl8G__reviews-info-mobile",
  "reviews-subtitle-mobile": "ReviewComments-module-scss-module__69nl8G__reviews-subtitle-mobile",
  "reviews-title-mobile": "ReviewComments-module-scss-module__69nl8G__reviews-title-mobile",
});
